import { NgModule } from '@angular/core';
import { BaseModule } from '../../shared/base.module';
import { DialogModule } from '../../dialog/dialog.module';
import { PatientMenuActionComponent } from './patient-menu-action.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
    imports: [
        BaseModule,
        DialogModule,
        BsDropdownModule.forRoot(),
        TooltipModule.forRoot(),
    ],
    exports: [PatientMenuActionComponent],
    declarations: [PatientMenuActionComponent],
    providers: [],
})

export class PatientMenuActionModule {
}
